import { Badge } from "../atoms/badges";
import { Progress } from "../atoms/progress";
import { TitleDescriptionText } from "../atoms/titleDescription";
import { Alert } from "../components/alert";

export const ProgressObj = ({ data, onClick, image, title, label, badge, percentage,description, className, message}) => {
  const imgSrc = image || `https://ui-avatars.com/api/?name=${title}`;
  const displayTitle = data?.course_name || title || "Geen titel beschikbaar";
  const displayDescription = data?.course_description || description || "Geen beschrijving beschikbaar";
  return (
    <div className={`progress-comp ${className}`} onClick={onClick}>
      <div className="fadeable">
        <Badge badge={badge} label={label} rounded={true} />
        <img className="course-img" src={imgSrc} alt={title} />
        <TitleDescriptionText className={"profile-page-title"} title={displayTitle} description={displayDescription} />
        {!message && percentage !== "none" && <Progress percentage={percentage} />}
      </div>
      {message && (  <Alert className="alert-no-entry" type="warning" message={message} /> )}
    </div>  
  );
};
